import { DOM_IDS } from "@circle-react-uikit/CircleAIAppShell/Layout/defaults";
import { createRouter } from "@tanstack/react-router";

import { SomethingWentWrong } from "@/react/components/shared/ErrorPages/SomethingWentWrong";
import { PageLoader } from "@/react/pages/PageLoader";

export const createTanstackRouter: typeof createRouter = options =>
  createRouter({
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    scrollToTopSelectors: ["#panel", `#${DOM_IDS.workspaceBody}`],
    defaultErrorComponent: props => (
      <SomethingWentWrong {...props} fullHeight />
    ),
    defaultPendingComponent: PageLoader,
    ...options,
  });
